import * as yup from 'yup';
import { FileUtil, FormValidationUtil, DateUtil } from '../../../utils';

export const initialValues = {
  otCategory: 'In Office',
  otDate: '',
  fromTime: '',
  toTime: '',
  reason: '',
  file: [],
  attachmentPath: '',
  hrs: 0,
  otHrs: '',
};

export const validationSchema = yup.object().shape({
  otCategory: yup.string().required('Please select an overtime category'),
  otDate: yup
    .date()
    .typeError('Please enter a valid date')
    .required('Overtime date is required'),
  fromTime: yup.string().required('From time is required'),
  toTime: yup
    .string()
    .required('End time is required')
    .test(
      'is-after-fromTime',
      'To time must be after from time',
      FormValidationUtil.toTimeAfterFromTime('fromTime'),
    ),
  reason: yup
    .string()
    .trim()
    .min(5, 'Reason must be at least 5 characters')
    .required('Reason is required'),
  hrs: yup
    .number()
    .typeError('Hours are required')
    .required('Hours are required'),
  otHrs: yup
    .number()
    .typeError('Overtime hours are required')
    .required('Overtime hours are required')
    .max(yup.ref('hrs'), 'Overtime hours cannot exceed calculated hours.'),
  file: yup
    .array()
    .min(1, 'Attachment is required')
    .test(
      'fileSize',
      `File size must be less than ${FileUtil.DEFAULT_ATTACHMENT_SIZE_MB}MB`,
      FormValidationUtil.validateMultipleFilesSize(
        FileUtil.DEFAULT_ATTACHMENT_SIZE_B,
      ),
    )
    .test(
      'fileFormat',
      FormValidationUtil.validateMultipleFilesFormatMessage(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
      FormValidationUtil.validateMultipleFilesFormat(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
    ),
});

export const populateFormValues = data => ({
  otCategory: data.OTCategory.trim() || '',
  otDate: DateUtil.formatDateTimeToHtmlDate(data?.Dt) || '',
  fromTime: data?.FromTime
    ? DateUtil.convertTimeToHTMLTimeRegex(data.FromTime)
    : '',
  toTime: data?.ToTime ? DateUtil.convertTimeToHTMLTimeRegex(data.ToTime) : '',
  attachmentPath: data?.AttachmentPath || '',
  reason: data?.Reason || '',
  otHrs: data?.OTHrs || '',
  hrs: data?.Hrs || '',
});
